import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Carmen', 'Laura', 'Ana', 'Patricia', 'Sofía', 'Valentina', 'Camila', 'Isabella', 'Lucía', 'Gabriela', 'Daniela', 'Andrea', 'Carolina', 'Fernanda'];
const CITIES = ['Buenos Aires', 'Santiago', 'Lima', 'Bogotá', 'Ciudad de México', 'Montevideo', 'Quito', 'Caracas', 'San José', 'Medellín', 'Guadalajara', 'Córdoba', 'Rosario', 'Valparaíso'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setNotification({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showNotification, 5000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 15 and 30 seconds
      const delay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      setTimeout(showNotification, delay);
    }, 20000); // Base interval check
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-52">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 max-w-sm bg-white rounded-lg shadow-lg border-l-4 border-green-500 p-4 flex items-center gap-3" data-id="element-53">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-54">
            <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-55" />
          </div>
          <div data-id="element-56">
            <p className="text-sm font-medium text-gray-900" data-id="element-57">
              {notification.name} de {notification.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-58">
              acaba de comprar{' '}
              <span className="font-semibold" data-id="element-59">Estrés en Pausa</span>
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}